<template>
  <vue-modal :name="modalId" :width="modalWidth"  :height="700" :scrollable="true" :clickToClose="false" >
    <div id="user-agreement-modal" class="modal-content" style="overflow: auto;">
<!--
-	User logs in for the first time
-	They are presented a screen with the User License Agreement in it (scrollable box)
-	Provide a way for them to print the agreement.
-	Tell the user to read/scroll to bottom of agreement.
-	Tell the user they need to accept or reject the agreement.
-	Provide a checkbox to accept and/or 2 buttons, one saying Reject and the other saying Accept.
-	If checkbox method, the Accept button doesn’t become active until it’s checked.
-	The checkbox should say “I accept all terms and conditions of this agreement.”
-	If they click Reject button, they are immediately logged back out.
-	If they click Accept, they gain access to the platform and don’t have to see this box anymore.        
-->        
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="close" @click="handleReject">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
            <div style="height:550px;">
              <vue-pdf-app :pdf="aggrementDoc" ref="myPdfComponent" @after-created="openModal"></vue-pdf-app>
            </div>  
            <div class="form-group form-inline ml-1 mt-2">
                <input type="checkbox" id="iAccept" name="iAccept" v-model="acceptAgreement" true-value="Y" false-value="N"/>
                <label for="iAccept" class="control-label ml-2">I accept all terms and conditions of this agreement.</label>
            </div>      
            <div class="d-flex justify-content-center mb-2">
              <button type="button" class="btn btn-primary ml-4" @click="handleAccept" :disabled="disableAcceptButton">Accept</button>
              <button type="button" class="btn btn-primary ml-4" @click="handleReject">Reject</button>
            </div>
        </div>            
      </div>
    </div>
  </vue-modal>
</template>

<script>
import ViewMixins from "../mixins/ViewMixins.vue";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import UserService from "../services/user.service.js";
import AdminService from "../services/admin.service.js";
export default {
  name: "UserAgreementModal",
  mixins: [ViewMixins],
  components: {VuePdfApp},
  data() {
    return {
      aggrementDoc: window.location.origin + '/pdf/2024-wRatings-User-License-Agreement.pdf',        
      modalReturnMessage: "",
      acceptAgreement: "N",
      disableAcceptButton: true,
    };
  },
  computed: {

  },
  mounted() {},
  created() {},
  methods: {
    openModal:function(){
      this.$modal.show(this.modalId);
    },
    closeModal: function(){
      this.$modal.hide(this.modalId);
    },     
    acceptUserAgreementCallback: function(response){
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.$notify(AdminService.displaySuccessMessage({ text: response.data.message }));
        let saveUser = UserService.getUser();
        saveUser.displayAgreement = 'N';
        UserService.saveUserToLocalStorage(saveUser);     
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
      this.$modal.hide(this.modalId);
    },
    handleAccept: function(){
      UserService.acceptUserAgreement(this.acceptUserAgreementCallback,this);
      
    },
    handleReject: function(){
      this.$modal.hide(this.modalId);
      this.$emit("logout");
    },
    getDownloadFilename(){
      return "2024-wRatings-User-License-Agreement";
    },      
    async getDocumentContents(){
      const doc = await fetch(this.aggrementDoc);
      const docBlob = await doc.blob();
      return docBlob;
    }, 
    async downloadAgreement() {
		    const docBlob = await this.getDocumentContents();	
        const blob = new Blob([docBlob], { type: "application/pdf" });
        this.clickLink(blob);
	  },
    clickLink(blob, includeExtention = false, extension = ".pdf"){
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = this.getDownloadFilename();
      if (includeExtention == true){
        link.download += extension;
      }
      link.click();
      URL.revokeObjectURL(link.href);      
    },     
  },
  watch: {
    acceptAgreement: function(val){
      if(val == "Y"){
        this.disableAcceptButton = false;
      } else {
        this.disableAcceptButton = true;
      }
    }   
  },
  props: {
    modalId: {
      type: String,
      default: "preview-locale",
    },
    modalTitle: {
      type: String,
      default: "",
    },
    modalWidth: {
      type: Number,
      default: 968
    },
  }
};
</script>
